import { Component, Inject, OnInit, HostBinding } from '@angular/core';
import { MediaService } from '@core/services/media.service';

@Component({
    selector: 'sfx-billing-usage',
    templateUrl: './billing-usage.component.html',
    styleUrls: ['./billing-usage.component.scss']
})
export class BillingUsageComponent implements OnInit {

    // Set flex attributes on the host selector
    @HostBinding('attr.data-flex') public readonly dataFlexAttr: string = 'grow';
    @HostBinding('attr.data-layout') public readonly layoutAttr: string = 'column';

    constructor(
        @Inject('modelService') public modelService: any,
        @Inject('stateService') public stateService: any,
        public media: MediaService
    ) {}

    public ngOnInit(): void {}

    get Stripe(): boolean {

        return this.modelService.me?.team?.subscribed && this.modelService.me?.team?.payment_type === 'stripe';
    }

    public close = (): any =>  {

        this.stateService.go('settings');
    };
}
